export default "<ion-nav #loginNav></ion-nav>";